import React from 'react';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import { Color, FontSize } from 'views/constants';
import { Typography } from 'views/components/atoms/Typography';
import { Button } from 'views/components/atoms/Button';
import { Image } from 'views/components/atoms/Image';
import iconImage from 'views/layouts/UnavailableInvitationPageLayout/images/icon.png';
import { localeIds } from 'locals';
import { FormattedMessage } from 'react-intl';

const Wrapper = styled.div`
  background-color: ${Color.C5};
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 66px 0;
`;

const LogoIconWrapper = styled.div`
  margin: auto;
  width: 160px;
  height: 156px;
`;

const ButtonWrapper = styled.div`
  width: 280px;
  margin: auto;
`;

interface UnavailableInvitationPageLayoutProps {
  onBack(): void;
}

export const UnavailableInvitationPageLayout: React.FC<
  UnavailableInvitationPageLayoutProps
> = ({ onBack }) => {
  return (
    <Wrapper>
      <div>
        <LogoIconWrapper>
          <Image src={iconImage} />
        </LogoIconWrapper>

        <Spacer size="large" />

        <Typography bold>
          <FormattedMessage id={localeIds.unavailableInvitation.title} />
        </Typography>

        <Spacer size="small" />

        <Typography size={FontSize.XS}>
          <Typography>
            <FormattedMessage
              id={localeIds.unavailableInvitation.message}
              values={{ br: () => <br /> }}
            />
          </Typography>
        </Typography>

        <Spacer size="large" />

        <ButtonWrapper>
          <Button type="button" style="secondary" onClick={onBack}>
            <FormattedMessage id={localeIds.unavailableInvitation.back} />
          </Button>
        </ButtonWrapper>
      </div>
    </Wrapper>
  );
};
